import { useState } from "react";
import { PackageSearch, PenLine } from "lucide-react";
import { CATEGORIES, categoryOf, formatPrice } from "@/lib/store";
import { MAX_ITEMS, stockLabel, toText } from "@/lib/proposal";
import { ModelPicker } from "@/components/site/ModelPicker";
import { ItemRows, pInput, ghostBtn } from "./ItemRows";

const catLabel = (p) => CATEGORIES.find((c) => c.id === categoryOf(p))?.plural || "Outros";
const order = (p) => CATEGORIES.findIndex((c) => c.id === categoryOf(p));

// Lista do estoque para o seletor (rótulos únicos, agrupados por categoria).
const stockOptions = (products) => {
  const seen = {};
  return [...products].sort((a, b) => order(a) - order(b)).map((p) => {
    const base = `${stockLabel(p)} — ${formatPrice(p.price)}`;
    seen[base] = (seen[base] || 0) + 1;
    return { p, label: seen[base] > 1 ? `${base} (${seen[base]})` : base };
  });
};

// "Você leva": aparelho do estoque (preço da vitrine) ou digitado à mão (ex.: sob encomenda).
export const ProposalWanted = ({ items, onChange, products }) => {
  const [picking, setPicking] = useState(false);
  const [query, setQuery] = useState("");
  const full = items.length >= MAX_ITEMS;
  const opts = stockOptions(products);
  const choose = (label) => {
    const hit = opts.find((o) => o.label === label);
    if (!hit) return setQuery(label);
    const { p } = hit;
    onChange([...items, { label: stockLabel(p), price: toText(p.price), source: "estoque", product_id: p.id }]);
    setQuery("");
    return setPicking(false);
  };
  return (
    <div data-testid="proposal-wanted">
      <p className="text-sm font-semibold text-white">Você leva</p>
      <ItemRows items={items} valueKey="price" onChange={onChange} testid="proposal-wanted" placeholder="Ex: iPhone 16 Pro 256GB · Novo (encomenda)" />
      {picking && (
        <div className="mt-3">
          <ModelPicker testid="proposal-stock" value={query} onChange={choose} options={opts.map((o) => o.label)}
            groupOf={(label) => catLabel(opts.find((o) => o.label === label)?.p)} placeholder="Digite para buscar no estoque (ex: 15 pro max)" className={pInput} />
        </div>
      )}
      <div className="mt-3 flex flex-wrap gap-2">
        <button type="button" data-testid="proposal-add-stock" disabled={full || !products.length} onClick={() => setPicking((v) => !v)} className={ghostBtn}><PackageSearch className="h-3.5 w-3.5" /> Do estoque</button>
        <button type="button" data-testid="proposal-add-wanted-manual" disabled={full} onClick={() => onChange([...items, { label: "", price: "", source: "manual" }])} className={ghostBtn}><PenLine className="h-3.5 w-3.5" /> Digitar à mão</button>
      </div>
    </div>
  );
};
